import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withNamespaces } from 'react-i18next';

class ContextualMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onClick = (action) => () => {
    this.clickOpen();
    action();
  };

  clickOpen = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  mouseLeave = () => {
    this.setState({ open: false });
  };

  render() {
    const { t } = this.props;
    let { items } = this.props;
    const { open } = this.state;
    items = items.filter(({ action, text }) => typeof action === 'function' && text.length);
    return items.length ? (
      <div className="action" onMouseLeave={this.mouseLeave} onClick={this.clickOpen}>
        <FontAwesomeIcon icon={{ iconName: 'ellipsis-h', prefix: 'fas' }} className="context-menu-icon" />
        {open && (
          <ul className="context-menu">
            {items.map(({ action, text, icon }) => (
              <li className="context-menu-item" key={text} id={`${text}-menu-item`}>
                <span className="context-menu-item-text with-pointer" onClick={this.onClick(action)} onKeyPress={this.onClick(action)} id={`${text}-span-text`}>
                  {icon && <FontAwesomeIcon icon={icon} className="menu-icon" />}
                  {t(text)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    ) : (
      ''
    );
  }
}

ContextualMenu.defaultProps = {
  items: [],
};

ContextualMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]),
      action: PropTypes.func,
      isText: PropTypes.bool,
    })
  ),
};

export default withNamespaces()(ContextualMenu);
